import React, { createContext, useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export const ProjectsContext = createContext();

export function ProjectsProvider({ children }) {
  const [projects, setProjects] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function fetchData() {
      try {
        const [projectsSnap, categoriesSnap] = await Promise.all([
          getDocs(collection(db, 'development')),
          getDocs(collection(db, 'development_categories'))
        ]);

        if (!isMounted) return;

        const allFetchedProjects = projectsSnap.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => {
            const nameA = (a.name || '').toLowerCase();
            const nameB = (b.name || '').toLowerCase();
            return nameA.localeCompare(nameB);
          });

        const fetchedProjects = allFetchedProjects
          .filter(project => project.is_active !== false);

        const fetchedCategories = categoriesSnap.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => {
            const orderA = a.order ?? 999;
            const orderB = b.order ?? 999;
            return orderA - orderB;
          });

        setProjects(fetchedProjects);
        setAllProjects(allFetchedProjects);
        setCategories(fetchedCategories);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        if (isMounted) {
          setProjects([]);
          setAllProjects([]);
          setCategories([]);
          setLoading(false);
        }
      }
    }

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <ProjectsContext.Provider value={{ projects, allProjects, categories, loading }}>
      {children}
    </ProjectsContext.Provider>
  );
}
